import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Switch.module.css.js';

const Switch = React__default.forwardRef(({ ...attrs }, ref) => {
    return (jsx("input", { ...attrs, ref: ref, type: "checkbox", className: classNames(style.switch, attrs.className) }));
});
Switch.displayName = "Switch";

export { Switch };
//# sourceMappingURL=Switch.js.map
